/* @ts-self-types="./mages_ffi.d.ts" */
import * as wasm from "./mages_ffi_bg.wasm";
import { __wbg_set_wasm } from "./mages_ffi_bg.js";

__wbg_set_wasm(wasm);
wasm.__wbindgen_start();
export {
    ChromaSampling, IntoUnderlyingByteSource, IntoUnderlyingSink, IntoUnderlyingSource, ShieldStateCode, WasmClient, base64Encode, init
} from "./mages_ffi_bg.js";
